module.exports = __webpack_public_path__ + "img/dianchi.aed2dc20.png";